import type { FC, ReactElement } from "react"

import { OwlSadImage } from "@/3514/assets"
import { ETypographyAlignment, Typography } from "@/3514/components"

import { ENetworkNoticeFallbackVariant as EVariant } from "./network-notice.types"

const _OwlSadComponent: FC = (): ReactElement => (
    <div className="w-fit px-[25px] flex items-center flex-col gap-y-[25px] mx-auto mt-[50px]">
        <OwlSadImage className="scale-[1]" />
        <Typography
            alignment={ETypographyAlignment.Center}
            text="Seems like you're currently offline. Please establish your connection to continue exploring this page."
        />
    </div>
)

const config: { [V in EVariant]: FC } = {
    [EVariant.OwlSad]: _OwlSadComponent
}

export { config as networkConfigGuardConfig }
